import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

type Props = {
    handleSubmit: (event: any) => void,
    children: JSX.Element,
};

const SearchInputWrapper: React.FC<Props> = ({
    handleSubmit,
    children, 
}) => {
    return (
    <Paper 
        component="form"
        onSubmit={handleSubmit} 
        elevation={6}
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', }}
    >
        {children}
        <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={handleSubmit}>
        <SearchIcon />
        </IconButton>
    </Paper>
    );
}

export default SearchInputWrapper;